var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.697,
    height: 17.697,
    viewBox: "0 0 17.697 17.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-external-link",
    "data-name": "Icon feather-external-link",
    transform: "translate(-3.5 -3.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    "data-name": "Trazado 61",
    d: "M17.235,14.943v5.094a1.7,1.7,0,0,1-1.7,1.7H6.2a1.7,1.7,0,0,1-1.7-1.7V10.7A1.7,1.7,0,0,1,6.2,9h5.094",
    transform: "translate(0 -1.953)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M22.5,4.5h5.094V9.594",
    transform: "translate(-7.812)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    "data-name": "Trazado 63",
    d: "M15,13.839,24.339,4.5",
    transform: "translate(-4.557)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutLink);
export default __webpack_public_path__ + "static/media/outLink.c09031d3cf705f5213758ff9660f9c99.svg";
export { ForwardRef as ReactComponent };